(function () {
  let featuredCollectionSlide = (scope = document) => {
    const dir = document.documentElement.getAttribute("dir");
    const isRtl = dir === "rtl";
    const cellAlign = dir === "rtl" ? "left" : "right";

    scope
      .querySelectorAll(".collection-product__slider.no-js-hidden")
      .forEach((sliderSection) => {
        const sliderElement = sliderSection.querySelector(
          ".collection-product-list"
        );
        const buttonsWrapper = sliderSection.querySelector(
          ".collection-product-list__buttons"
        );

        if (!sliderElement || !buttonsWrapper) {
          return;
        }

        let carousel = Flickity.data(sliderElement);

        if (!carousel) {
          carousel = new Flickity(sliderElement, {
            autoPlay: false,
            pageDots: false,
            draggable: true,
            prevNextButtons: false,
            rightToLeft: isRtl,
            cellAlign,
            groupCells: true,
            friction: 1,
            selectedAttraction: 0.08,
          });
        } else {
          carousel.resize();
        }

        const buttonNext = buttonsWrapper.querySelector(
          ".collection-product-list__button--next"
        );
        const buttonPrev = buttonsWrapper.querySelector(
          ".collection-product-list__button--prev"
        );

        if (!buttonNext || !buttonPrev) {
          return;
        }

        const forwardButton = isRtl ? buttonPrev : buttonNext;
        const backwardButton = isRtl ? buttonNext : buttonPrev;

        const updateButtonsState = () => {
          const lastIndex = Math.max(carousel.slides.length - 1, 0);
          const isAtStart = carousel.selectedIndex <= 0;
          const isAtEnd = carousel.selectedIndex >= lastIndex;

          backwardButton.disabled = isAtStart;
          forwardButton.disabled = isAtEnd;
        };

        if (!buttonNext.dataset.featuredCollectionBound) {
          buttonNext.addEventListener("click", () => {
            if (isRtl) {
              carousel.previous();
            } else {
              carousel.next();
            }
          });
          buttonNext.dataset.featuredCollectionBound = "true";
        }

        if (!buttonPrev.dataset.featuredCollectionBound) {
          buttonPrev.addEventListener("click", () => {
            if (isRtl) {
              carousel.next();
            } else {
              carousel.previous();
            }
          });
          buttonPrev.dataset.featuredCollectionBound = "true";
        }

        carousel.off("select", updateButtonsState);
        carousel.off("settle", updateButtonsState);
        carousel.on("select", updateButtonsState);
        carousel.on("settle", updateButtonsState);
        updateButtonsState();
      });
  };

  const calcHeight = () => {
    const card = document.querySelector(".featured-collection-section__card");
    if (!card) {
      return;
    }

    const featuredcollectionSections = document.querySelectorAll(
      ".featured-collection-section"
    );
    const cardRect = card.getBoundingClientRect();
    const cardHeight = cardRect.height;
    featuredcollectionSections.forEach((section) => {
      section.style.paddingBottom = `${cardHeight / 2}px`;
    });
  };

  document.addEventListener("shopify:section:load", function (event) {
    featuredCollectionSlide(event.target);
    calcHeight();
  });

  window.addEventListener("load", () => {
    featuredCollectionSlide();
  });

  calcHeight();
})();
